/**
 * Anzeigename und Dateityp eines Dokuments aus seinem Link.
 *
 * Den gespeicherten Namen setzt der Server (`dokumentname_aus_url` im Backend). Hier steht
 * dieselbe Regel nur für die Vorschau: ein eben eingetragener Link, der noch nicht gespeichert
 * ist, und der Platzhalter im Namensfeld.
 */

const segmente = (url: string): { pfad: string[]; host: string } => {
  try {
    const geparst = new URL(url.trim());
    return {
      pfad: geparst.pathname.split("/").filter(Boolean),
      host: geparst.host,
    };
  } catch {
    // Kein vollständiger Link (etwa nur ein Pfad) – dann zählt, was nach dem letzten "/" steht.
    return {
      pfad: url.trim().split("?")[0].split("/").filter(Boolean),
      host: "",
    };
  }
};

const dateiname = (url: string): string | null => {
  const { pfad } = segmente(url);
  if (pfad.length === 0) return null;
  try {
    return decodeURIComponent(pfad[pfad.length - 1]);
  } catch {
    return pfad[pfad.length - 1];
  }
};

/** Dateiendung in Kleinbuchstaben ohne Punkt („pdf“), leer ohne erkennbare Endung */
export const dateiendung = (url: string): string => {
  const name = dateiname(url);
  const punkt = name?.lastIndexOf(".") ?? -1;
  return name && punkt > 0 ? name.slice(punkt + 1).toLowerCase() : "";
};

/** Dateiname ohne Endung, ohne Dateinamen der Host, sonst der Link selbst */
export const dokumentnameAusUrl = (url: string): string => {
  const name = dateiname(url);
  if (name) {
    const punkt = name.lastIndexOf(".");
    return (punkt > 0 ? name.slice(0, punkt) : name).trim() || name;
  }
  return segmente(url).host || url.trim();
};

/** Was angezeigt wird: der gespeicherte Name, sonst der aus der URL abgeleitete */
export const dokumentAnzeigename = (dokument: {
  url: string;
  name?: string | null;
}): string => dokument.name?.trim() || dokumentnameAusUrl(dokument.url);
